import BaseValidator from "./base_validator"

export default class UniquenessValidator extends BaseValidator {
  validate() {
    let valid = true
    let errorMessage = ''

    if (this.blank || !this.shouldCheck()) return { valid: valid, message: errorMessage }

    const response = this.fetchUniqueness()
    if (!response.result.uniq) {
      valid = false
      errorMessage = this.errorMessages['taken']
    }

    return { valid: valid, message: errorMessage }
  }

  // Onboarding solo consulta al dar de alta. Un formulario que edita un registro existente
  // opta por la consulta declarando el modelo en el input, y manda su id para excluirse: ahi la
  // pregunta no es "existe" sino "lo tiene alguien mas".
  shouldCheck() {
    return this.uniquenessData !== null || (this.newRecord !== '' && this.newRecord === 'true')
  }

  get uniquenessData() {
    const dataset = this.element ? this.element.dataset : null
    if (!dataset || !dataset.uniquenessModel) return null

    return {
      model: dataset.uniquenessModel,
      field: dataset.uniquenessField,
      excludeId: dataset.uniquenessExcludeId || ''
    }
  }

  fetchUniqueness() {
    const data = this.uniquenessData || this.dataFromId()
    let url = `/validations?model=${data.model}&field=${data.field}&value=${encodeURIComponent(this.value)}`
    if (data.excludeId) url += `&exclude_id=${encodeURIComponent(data.excludeId)}`

    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, false)
    xhr.overrideMimeType('application/json')
    xhr.send(null)

    return JSON.parse(xhr.responseText)
  }

  dataFromId() {
    const model = this.id.split('_')[0]

    return { model: model, field: this.id.replace(`${model}_`, ''), excludeId: '' }
  }
}
